/* Arrows */
export default function Style(){
  return (
    <style>
      {`
      .FeatureSlider .left-arrow {
  left: -10px !important;
  color: black;
  outline: none;
  position: absolute;
  top: 43%;
  z-index: 1;
}

.FeatureSlider .right-arrow {
  right: -10px !important;
  color: black;
  outline: none;
  position: absolute;
  top: 43%;
  z-index: 1;
}


.FeatureSlider .left-arrow .right-arrow {
  font-size: 0;
  line-height: 0;
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: transparent;
  border: none;
  outline: none;
  background: transparent;
}

.FeatureSlider .left-arrow:hover {
  color: black !important;

}

.FeatureSlider .right-arrow:hover {
  color: black !important;

}

.FeatureSliderBlack .left-arrow .right-arrow {
  font-size: 0;
  line-height: 0;
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: transparent;
  border: none;
  outline: none;
  background: transparent;
}


/* Arrows */
.FeatureSliderBlack .left-arrow {
  left: -10px !important;
  color: #fff;
  outline: none;
  position: absolute;
  top: 43%;
  z-index: 1;
}

.FeatureSliderBlack .right-arrow {
  right: -10px !important;
  color: #fff;
  outline: none;
  position: absolute;
  top: 43%;
  z-index: 1;
}

.FeatureSliderBlack .left-arrow:hover {
  color: #fff !important;

}

.FeatureSliderBlack .right-arrow:hover {
  color: #fff !important;

}

      `}
    </style>
  );
}
